module.exports = __webpack_public_path__ + "img/statistics_khs.7dfbf6b8.png";